import React, { useState, useEffect } from "react";
import Context from "./Context";

const ContextProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState(() => {
    const storedCartItems = JSON.parse(localStorage.getItem("cartItems"));
    return storedCartItems || [];
  });

  const [searchTerm, setSearchTerm] = useState("");
  const [unreadMessageCount, setUnreadMessageCount] = useState("");

  const [wishlistItems, setWishlistItems] = useState(() => {
    const storedWishlist = JSON.parse(localStorage.getItem("wishList"));
    return storedWishlist || [];
  });

  const [discount, setDiscount] = useState(() => {
    const storedDiscount = localStorage.getItem("discount");
    return storedDiscount ? parseFloat(storedDiscount) : 0;
  });

  useEffect(() => {
    localStorage.setItem("cartItems", JSON.stringify(cartItems));
  }, [cartItems]);

  useEffect(() => {
    localStorage.setItem("wishList", JSON.stringify(wishlistItems));
  }, [wishlistItems]);

  useEffect(() => {
    localStorage.setItem("discount", discount.toString());
  }, [discount]);

  const addToCart = (product, userQuantity = 1) => {
    setCartItems((prevCartItems) => {
      const existingProduct = prevCartItems.find(
        (item) => item.id === product.id
      );
      if (existingProduct) {
        return prevCartItems.map((item) =>
          item.id === product.id
            ? { ...item, userQuantity: item.userQuantity + userQuantity }
            : item
        );
      } else {
        return [
          ...prevCartItems,
          { ...product, userQuantity, stockQuantity: product.stockQuantity },
        ];
      }
    });
  };

  const updateCartItemQuantity = (itemId, newUserQuantity) => {
    setCartItems((prevCartItems) =>
      prevCartItems.map((item) =>
        item.id === itemId ? { ...item, userQuantity: newUserQuantity } : item
      )
    );
  };

  const removeCartItem = (itemId) => {
    setCartItems((prevCartItems) =>
      prevCartItems.filter((item) => item.id !== itemId)
    );
  };

  const applyDiscount = (value) => {
    setDiscount(value);
  };

  const addToWishlist = (product, userQuantity = 1) => {
    setWishlistItems((prevWishlistItems) => {
      const existingProduct = prevWishlistItems.find(
        (item) => item.id === product.id
      );
      if (existingProduct) {
        return prevWishlistItems.map((item) =>
          item.id === product.id
            ? { ...item, userQuantity: item.userQuantity + userQuantity }
            : item
        );
      } else {
        return [...prevWishlistItems, { ...product, userQuantity }];
      }
    });
  };

  const updateWishlistItemQuantity = (itemId, newUserQuantity) => {
    setWishlistItems((prevWishlistItems) =>
      prevWishlistItems.map((item) =>
        item.id === itemId ? { ...item, userQuantity: newUserQuantity } : item
      )
    );
  };

  const removeWishlistItem = (itemId) => {
    setWishlistItems((prevWishlistItems) =>
      prevWishlistItems.filter((item) => item.id !== itemId)
    );
  };

  return (
    <Context.Provider
      value={{
        cartItems,
        wishlistItems,
        discount,
        addToCart,
        updateCartItemQuantity,
        removeCartItem,
        applyDiscount,
        addToWishlist,
        updateWishlistItemQuantity,
        removeWishlistItem,
        searchTerm,
        setSearchTerm,
      }}
    >
      {children}
    </Context.Provider>
  );
};

export default ContextProvider;
